import type { Template } from "@/types";

export const PO_04_H3_V1: Template[] = [
{
    id: "po-04-h3v1-01",
    name: "PO 01 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 97, y: 100, width: 415, height: 651, rotation: 0, imageRotation: 0 },
            { id: "2", x: 761, y: 0, width: 375, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 761, y: 287, width: 375, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 761, y: 573, width: 375, height: 278, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-04-h3v1-02",
    name: "PO 02 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 54, y: 60, width: 465, height: 730, rotation: 0, imageRotation: 0 },
            { id: "2", x: 817, y: 60, width: 345, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 817, y: 307, width: 345, height: 239, rotation: 0, imageRotation: 0 },
            { id: "4", x: 817, y: 553, width: 345, height: 238, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-03",
    name: "PO 03 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_03.png",
    size: [1217, 851],
    style: {},
    slots: [    
        { id: "1", x: 115, y: 60, width: 345, height: 239, rotation: 0, imageRotation: 0 },
        { id: "2", x: 115, y: 307, width: 345, height: 238, rotation: 0, imageRotation: 0 },
        { id: "3", x: 115, y: 553, width: 345, height: 238, rotation: 0, imageRotation: 0 },
        { id: "4", x: 680, y: 60, width: 465, height: 730, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-04",
    name: "PO 04 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 83, y: 187, width: 443, height: 292, rotation: 0, imageRotation: 0 },    
        { id: "2", x: 83, y: 486, width: 218, height: 160, rotation: 0, imageRotation: 0 },
        { id: "3", x: 309, y: 486, width: 217, height: 160, rotation: 0, imageRotation: 0 },
        { id: "4", x: 685, y: 69, width: 455, height: 714, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-05",
    name: "PO 05 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 82, y: 362, width: 443, height: 293, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 82, y: 196, width: 218, height: 159, rotation: 0, imageRotation: 0 },
        { id: "3", x: 308, y: 196, width: 217, height: 159, rotation: 0, imageRotation: 0 },
        { id: "4", x: 766, y: 196, width: 293, height: 459, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-06",
    name: "PO 06 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 51, y: 174, width: 508, height: 334, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 51, y: 516, width: 250, height: 178, rotation: 0, imageRotation: 0 },
        { id: "3", x: 309, y: 516, width: 250, height: 178, rotation: 0, imageRotation: 0 },
        { id: "4", x: 609, y: 1, width: 608, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-07",
    name: "PO 07 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 72, y: 60, width: 465, height: 730, rotation: 0, imageRotation: 0 },
        { id: "2", x: 686, y: 361, width: 453, height: 299, rotation: 0, imageRotation: 0 },
        { id: "3", x: 686, y: 190, width: 223, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 917, y: 190, width: 223, height: 164, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-08",
    name: "PO 08 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_08.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 0, y: 181, width: 298, height: 241, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 430, width: 298, height: 240, rotation: 0, imageRotation: 0 },
        { id: "3", x: 306, y: 181, width: 604, height: 489, rotation: 0, imageRotation: 0 },
        { id: "4", x: 918, y: 181, width: 298, height: 489, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-09",
    name: "PO 09 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 50, y: 58, width: 443, height: 735, rotation: 0, imageRotation: 0 },
        { id: "2", x: 501, y: 58, width: 668, height: 499, rotation: 0, imageRotation: 0 },
        { id: "3", x: 501, y: 565, width: 330, height: 228, rotation: 0, imageRotation: 0 },
        { id: "4", x: 839, y: 565, width: 330, height: 228, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-10",
    name: "PO 10 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 186, y: 80, width: 286, height: 391, rotation: 0, imageRotation: 0 },
        { id: "2", x: 480, y: 80, width: 550, height: 391, rotation: 0, imageRotation: 0 },
        { id: "3", x: 186, y: 479, width: 419, height: 294, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 479, width: 418, height: 294, rotation: 0, imageRotation: 0 }
    ],
}
];